import { Alert, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField, useMediaQuery } from '@mui/material'
import axiosInstance from 'custom-axios';
import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';


const EftInformation = ({ accountTypeId, formAccountData, userId, setFormAccountData, activeAccountStep, setActiveAccountStep }) => {

    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [transferDetails, setTransferDetails] = useState(formAccountData.transfer_details);
    const [selectedBankAccountNumber, setSelectedBankAccountNumber] = useState('');
    const [eEftDetails, setEftDetails] = useState();
    const [hideFormData, setHideFormData] = useState(false)
    const [investmentAccountData, setInvestmentAccountData] = useState([])
    const [filteredAccountDetails, setFilteredAccountDetails] = useState([]); // for bank account number

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useFormContext();

    useEffect(() => {
        setValue('eft_information', eEftDetails);
        setValue('filtered_account_details', filteredAccountDetails);
    }, [eEftDetails, filteredAccountDetails, setValue]);

    const fetchBankInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);

            if (response.data.length > 0) {

                setTransferDetails(response.data);
                /* const defaultBankAccountNumber = response.data[0].bank_account_number;

                const filteredData = response.data.filter(
                    (detail) => detail.bank_account_number === defaultBankAccountNumber
                );

                setEftDetails(filteredData); */
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchEftData = async () => {

        try {
            const response = await axiosInstance.get(`api/get-user-eft-info/${userId}`);

            setHideFormData(response.is_applicable)

            if (response.data) {
                setEftDetails(response.data);
                setInvestmentAccountData(response.eft_investment_account_details)
                setSelectedBankAccountNumber(response.data[0].bank_account_number);

                // const defaultBankAccountNumber = response.data.eft_investment_account_id;

                // const filteredData = response.data.filter(
                //     (detail) => detail.eft_investment_account_id == defaultBankAccountNumber
                // );

                setFilteredAccountDetails(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }


    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                }));
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleDropdownChange = (event) => {
        const bankAccountNumber = event.target.value;
        setSelectedBankAccountNumber(bankAccountNumber);

        // call and api here instead of filter data according  selected account number....
        const filteredData = transferDetails.filter(
            (detail) => detail.bank_account_number === bankAccountNumber
        );

        setFilteredAccountDetails(filteredData);

        setEftDetails((prevData => ({
            ...prevData,
            bank_account_number: filteredData[0].bank_account_number,
            bank_name: filteredData[0].bank_name,
            bank_transit_number: filteredData[0].bank_transit_number,
            bank_institution_number: filteredData[0].bank_institution_number,
        })))

        // store to main data for store from account stepper
        setFormAccountData(prevData => ({
            ...prevData,
            eft_information: filteredData
        }));
    };

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        const submitData = { user_id: userId ? userId : 0, parent_step: 1, child_step: activeAccountStep - 1 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(activeAccountStep - 1);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const submitForm = async () => {

        setFormAccountData(prevData => ({
            ...prevData,
            eft_information: eEftDetails
        }));

        let endPoint = `api/save-user-etf-info`;

        let modifiedChildStep = activeAccountStep + 1

        /* if (formAccountData.account_pac == 2 && formAccountData.account_swp == 2 && formAccountData.account_income_sweep == 2) {
            modifiedChildStep = 7;

        } else {
            const stepsToCheck = [
                { stepIndex: 5, value: formAccountData.account_pac },
                { stepIndex: 6, value: formAccountData.account_swp },
                { stepIndex: 7, value: formAccountData.account_income_sweep },
            ];

            // Find the highest-priority step where the value is 1
            for (const step of stepsToCheck) {
                if (step.value === 1) {
                    modifiedChildStep = step.stepIndex;
                    break;
                }
            }
        } */

        const submitData = { ...eEftDetails[0], ...filteredAccountDetails[0], login_id: formAccountData.login_id, accountTypeId: 1, user_id: userId ? userId : 0, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
        }
    }

    useEffect(() => {
        fetchBankInfoData()
        fetchEftData()
        fetchAccountTypeInfoData()
    }, [])


    return (
        <>
            <form onSubmit={handleSubmit(submitForm)}>
                {hideFormData &&
                    <Grid container spacing={2} className='p-4'>

                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="swp_account-details" className='font15px'>Select Existing Investment Account</label>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl
                                fullWidth
                                size="small"
                                error={Boolean(errors && errors['eft_investment_account_id '])}
                            >
                                <InputLabel id="select-account-details">Investment Account</InputLabel>
                                <Select
                                    labelId="select-account-details"
                                    label='Investment Account'
                                    value={eEftDetails[0].eft_investment_account_id || ''}
                                    classes={{ select: "custom-select-label" }}
                                    MenuProps={{
                                        disableScrollLock: true,
                                        PaperProps: { sx: { maxHeight: 200 } }
                                    }}
                                    onChange={(e) => {
                                        const updatedBankDetails = [...eEftDetails];
                                        updatedBankDetails[0].eft_investment_account_id = e.target.value;
                                        setEftDetails(updatedBankDetails);
                                    }}
                                    inputProps={register('eft_investment_account_id ', {
                                        required: true
                                    })}
                                >
                                    {investmentAccountData.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={12} sm={12} md={4}></Grid>


                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                            <label htmlFor="bank-name" className='font15px'>Account Number</label>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl
                                fullWidth
                                size="small"
                            >
                                <InputLabel id="select-tpi-instruction_currency">Account Number</InputLabel>
                                <Select
                                    labelId="select-tpi-instruction_currency"
                                    label="Account Number"
                                    value={selectedBankAccountNumber}
                                    classes={{ select: "custom-select-label" }}
                                    name='instruction_currency'
                                    MenuProps={{
                                        disableScrollLock: true,
                                        PaperProps: { sx: { maxHeight: 200 } }
                                    }}
                                    onChange={handleDropdownChange}
                                >
                                    {transferDetails.map((detail) => (
                                        <MenuItem key={detail.id} value={detail.bank_account_number}>
                                            {detail.bank_account_number}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}></Grid>

                        {filteredAccountDetails?.map((item, index) => {

                            return (
                                <React.Fragment key={index}>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Name Of Bank"
                                            fullWidth
                                            InputLabelProps={item.bank_name ? { shrink: true } : {}}
                                            size="small"
                                            name='bank_name'
                                            disabled
                                            value={item.bank_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Bank Transit Number"
                                            fullWidth
                                            size="small"
                                            name='bank_transit_number'
                                            disabled
                                            InputLabelProps={item.bank_transit_number ? { shrink: true } : {}}
                                            value={item.bank_transit_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>

                                        <TextField
                                            label="Institution Number"
                                            fullWidth
                                            size="small"
                                            name='bank_institution_number'
                                            disabled
                                            InputLabelProps={item.bank_institution_number ? { shrink: true } : {}}
                                            value={item.bank_institution_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>


                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-account-number" className='font15px'>Bank Account Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextField
                                            label="Bank Account Number"
                                            fullWidth
                                            size="small"
                                            name='bank_account_number'
                                            disabled
                                            InputLabelProps={item.bank_account_number ? { shrink: true } : {}}
                                            value={item.bank_account_number}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </React.Fragment>
                            )
                        })}
                    </Grid>
                }


                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                            // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for Eft.
                            </Alert>
                        </Grid>
                    </div>
                }
                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form>
            <ToastContainer />
        </>
    )
}
export default EftInformation